/****   request.js   ****/
// 导入axios
import axios from 'axios'
// 使用element-ui Message做消息提醒
import {
  Message
} from 'element-ui';
import {
  setToken,
  getToken,
  removeToken
} from "@/assets/js/auth.js";
import Router from '@/router/index';
import store from '../store/index.js';
import { waitForAutoLogin } from '@/assets/js/autoLogin.js';

//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  baseURL: process.env.BASE_API,
  // 超时时间 单位是ms
  timeout: 15 * 1000
})

// 2.请求拦截器
service.interceptors.request.use(async config => {
  await waitForAutoLogin();
  let token = '';
  let userId = ''
  if (getToken('USER_Msg')) {
    token = JSON.parse(getToken('USER_Msg')).token;
    userId = JSON.parse(getToken('USER_Msg')).user_id;
  } else if (store.state.user.token) {
    token = store.state.user.token;
    userId = store.state.user.user_id;
  }
  config.headers = {
    'content-Type': 'application/x-www-form-urlencoded',
    'X-Remote-User': userId
  }
  if (token) {
    config.headers.token = token;
  }
  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  if (response.data.msg == '您没有权限执行此操作!' && (window.location.pathname != '/Home' && window.location.pathname !=
      '/newCompany')) {
    Router.replace('/NoPermissions');
  }
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  if (response.status == 200) {
    let data = response.data;
    if (data.errorCode == 10001 || data.errorCode == 10003) {
      Router.replace('/login');
      removeToken("USER_Msg")
      return
    }
    return data
  }

}, error => {
  console.log(error);
  /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    if (error.code == "ECONNABORTED") {
      Router.replace('/login');
      return
    }
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break;
      case 401:
        error.message = '未授权，请重新登录'
        break;
      case 403:
        error.message = '拒绝访问'
        break;
      case 404:
        error.message = '请求错误,未找到该资源'
        break;
      case 405:
        error.message = '请求方法未允许'
        break;
      case 408:
        error.message = '请求超时'
        break;
      case 500:
        error.message = '服务器端出错'
        break;
      case 501:
        error.message = '网络未实现'
        break;
      case 502:
        error.message = '网络错误'
        break;
      case 503:
        error.message = '服务不可用'
        break;
      case 504:
        error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页')
    }
    error.message = '连接服务器失败'
  }

  Message.error(error.message)
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  // return Promise.resolve(error.response)
})
//4.导入文件
export default service


// WEBPACK FOOTER //
// ./src/api/request.js